import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import useConfirmDialog from '../useConfirmDialog';
import css from './DeleteIcon.css';

const ICON_NAME = {
    x: 'x',
    trash: 'trash',
};

const DeleteIcon = ({
    className,
    icon = 'x',
    confirmTitleKey,
    confirmTextKey,
    getConfirmOptions,
    onConfirm,
    shouldConfirm = true,
}) => {
    const { confirm, dialog } = useConfirmDialog();

    const handleClick = useCallback(
        e => {
            e.stopPropagation();
            if (!shouldConfirm) {
                onConfirm();
                return;
            }
            if (getConfirmOptions) {
                const opts = getConfirmOptions();
                confirm({
                    titleKey: opts.titleKey,
                    textKey: opts.textKey || '',
                    body: opts.body,
                    onConfirm,
                });
                return;
            }
            confirm({
                titleKey: confirmTitleKey,
                textKey: confirmTextKey,
                onConfirm,
            });
        },
        [confirm, shouldConfirm, confirmTitleKey, confirmTextKey, getConfirmOptions, onConfirm]
    );

    return (
        <>
            <Icon
                name={ICON_NAME[icon] || ICON_NAME.x}
                size={IconSizes.X_SMALL}
                variant={IconVariants.ERROR}
                className={classNames(css.deleteIcon, className)}
                onClick={handleClick}
            />
            {dialog}
        </>
    );
};

DeleteIcon.propTypes = {
    confirmTitleKey: PropTypes.string,
    confirmTextKey: PropTypes.string,
    getConfirmOptions: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
    shouldConfirm: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.oneOf(['x', 'trash']),
};

export default DeleteIcon;
